import decorateWithProps from 'decorate-component-with-props';
import {
    TEST_ID,
    NO_WEB_PUSH,
    WITH_WEB_PUSH
} from '../../../../shared/abtests/webPush';

import { Variant } from '@pegasus/abtesting';

export const NoWebPushVariant = decorateWithProps(Variant, {
    experimentId: TEST_ID,
    value: NO_WEB_PUSH,
    control: true,
});

export const WithWebPushVariant = decorateWithProps(Variant, {
    experimentId: TEST_ID,
    value: WITH_WEB_PUSH,
});

